import type { UserDetail } from "@shared/types/user";
import type { SystemProfileDetail } from "./types";

function formatLoginTime(value?: number | null): string {
    if (value === undefined || value === null || value <= 0) return "--";
    const ms = value > 1e12 ? value : value * 1000;
    const date = new Date(ms);
    if (Number.isNaN(date.getTime())) return "--";
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

/** 将 user/info.userDetail 转为个人中心展示结构 */
export function mapUserDetailToProfile(detail: UserDetail): SystemProfileDetail {
    return {
        id: detail.id,
        username: detail.username,
        nick: detail.nick || "",
        tel: detail.tel || "",
        email: detail.email || "",
        avatar: detail.avatar || "",
        identity: detail.identity,
        corpName: detail.corpName || "",
        roleNames: [],
        createTime: "--",
        lastLoginTime: formatLoginTime(detail.lastLoginTime),
        lastLoginIp: detail.lastLoginIp || "--",
    };
}
